import React, { useState, useEffect } from 'react';

import {
  AsyncSelect,
  Checkbox,
  Input,
  InputDate,
  SimpleSelect
} from '../../../components/Input.components';
import { Grid } from '../../../components/Grid.components';
import { Boxed } from '../../../components/Boxed.components';
import { Text } from '../../../components/Text.components';
import { Button } from '../../../components/Button.components';
import { PageTitle } from '../../../components/style';
import FormBuilder from './FormBuilder';
import PreviewForm from './PreviewForm';
import FormSettings from './FormSettings';
import { Alert } from '../../../components/Alert.components';
import { Tabs, Tab } from 'react-bootstrap';
import { position } from 'polished';

export const CreateRequestForm = (props) => {
  // State props
  const { isLoading, isLoadingDepartments, activeOrganisation } = props;

  // Dispatch props
  const { form, createAction, fetchAllDepartments, usersList, redirect } = props;
  const { getFieldProps, getFieldError, validateFields } = form;

  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const [dynamicForm, setDynamicForm] = useState([]);
  const [steps, setSteps] = useState([
    {
      id: 1,
      reviewers: [],
      defaultCriteria: 0,
      additionalCriteria: 0
    }
  ]);
  const [upload, setUpload] = useState(false);

  console.log(steps);
  console.log({ upload });
  const currentUser = JSON.parse(localStorage.getItem('dapproval_app_profile'));
  const onSubmit = () => {
    validateFields((error, values) => {
      if (!error) {
        if (dynamicForm?.task_data?.length < 1) {
          Alert.error("You haven't created a form yet");
          return;
        }
        if (steps?.length < 1) {
          Alert.error('Please add steps to continue');
          return;
        }

        const payload = {
          title: values?.title?.trim(),
          description: values?.description?.trim(),
          steps:
            steps?.map((item, index) => ({
              position: index,
              criteriaOfAcceptance: item.defaultCriteria,
              reviewers: item?.reviewers?.map((elem) => elem?.value)
            })) ?? [],
          fields: dynamicForm?.task_data ?? [],
          organization: activeOrganisation?._id,
          createdBy: currentUser._id,
          allowAttachments: upload
        };
        createAction(payload);
      }
    });
  };

  return (
    <>
      <Boxed pad="20px">
        <PageTitle>Request Config / Create </PageTitle>
        <Text>Create a new Request Form</Text>
        <Boxed maxWidth="500px">
          <Boxed pad="10px 0">
            <Input
              type="text"
              label="Request Title"
              placeholder="Enter request title..."
              error={getFieldError('title') ? 'Request title is required' : null}
              {...getFieldProps('title', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>
          <Boxed pad="10px 0">
            <Input
              type="text"
              label="Request Description"
              placeholder="Enter request description..."
              error={getFieldError('description') ? 'Request Description is required' : null}
              {...getFieldProps('description', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>
          <Boxed pad="10px 0">
            <Checkbox
              label="Allow upload of supporting documents"
              checked={upload}
              onClick={() => setUpload(!upload)}
            />
             {/* {upload && (
              <Input
                type="number"
                label="Maximum files allowed"
                placeholder="Maximum files allowed..."
                error={
                  getFieldError("minimumUpload")
                    ? "Request Description is required"
                    : null
                }
                {...getFieldProps("minimumUpload", {
                  initialValue: "",
                  rules: [{ required: false }],
                })}
              />
            )} */}
          </Boxed>
        </Boxed>

        <Boxed pad="10px 0" display="flex">
          <Button clear margin="0 10px 0 auto" onClick={() => redirect('/requests')}>
            Cancel
          </Button>
          <Button loading={isLoading} disabled={isLoading} onClick={() => onSubmit()}>
            Create Form
          </Button>
        </Boxed>
        <Tabs
          defaultActiveKey="form_builder"
          id="uncontrolled-tab-example"
          className="mb-10"
          // className="flex-column"
        >
          <Tab eventKey="form_builder" title="Form Builder">
            <FormBuilder form={dynamicForm} setForm={setDynamicForm} />
          </Tab>
          <Tab eventKey="form_preview" title="Preview Form">
            <PreviewForm form={dynamicForm} />
          </Tab>
          <Tab eventKey="form_settings" title="Advance Settings">
            <FormSettings allUsers={usersList} updateStep={setSteps} allSteps={steps}/>
          </Tab>
        </Tabs>
      </Boxed>
    </>
  );
};
